// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__21GbZ","col":"Table_col__3jvUq","fulfillmentStatus":"Table_fulfillmentStatus__3HF5g","emailCol":"Table_emailCol__g6thu"};